/**
 * Project Table of Contents — smooth scroll + mobile toggle.
 *
 * The ToC HTML and heading IDs are generated server-side by the
 * `story_toc` / `story_with_heading_ids` Django template tags.
 * This script only adds interactivity:
 *   - Smooth scrolling when clicking ToC anchor links
 *   - Mobile collapsible toggle
 */
(function () {
  'use strict';

  function init() {
    var tocNav = document.querySelector('.toc-nav');
    if (!tocNav) return;

    // ——— Smooth scroll for ToC anchor links ————————————————————————
    tocNav.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!link) return;

      var href = link.getAttribute('href');

      // Heading link
      var targetId = href.substring(1);
      var targetEl = document.getElementById(targetId);
      if (targetEl) {
        e.preventDefault();
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + targetId);
      }
    });

    // ——— Mobile collapsible toggle —————————————————————————————————
    var toggleBtn = tocNav.querySelector('.toc-mobile-toggle');
    if (!toggleBtn) return;

    var listId = toggleBtn.getAttribute('aria-controls');
    var tocList = listId ? document.getElementById(listId) : null;

    toggleBtn.addEventListener('click', function () {
      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));

      if (tocList) tocList.classList.toggle('toc-collapsed');

      var chevron = toggleBtn.querySelector('.toc-chevron');
      if (chevron) chevron.classList.toggle('toc-chevron-expanded');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
